import { render } from "./CometChatMessages.vue?vue&type=template&id=5c64500d&scoped=true"
import script from "./CometChatMessages.vue?vue&type=script&lang=js"
export * from "./CometChatMessages.vue?vue&type=script&lang=js"

import "./CometChatMessages.vue?vue&type=style&index=0&id=5c64500d&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c64500d"]])

export default __exports__